document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded - helmet upsell ready");

  // Find all Add to Cart buttons
  const addToCartButtons = document.querySelectorAll(
    'form[action="/cart/add"] button[type="submit"]'
  );
  console.log("Found Add to Cart buttons:", addToCartButtons.length);

  // Add click event listeners to Add to Cart buttons
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      console.log("Add to Cart button clicked");

      // Prevent default form submission
      event.preventDefault();

      // Get the form
      const form = this.closest('form[action="/cart/add"]');

      // Submit the form via AJAX
      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart:", data);

          if (this.classList.contains("has-upsell")) {
            showUpsellPopup();
          }

          // Update cart count/drawer if needed
          if (window.theme && window.theme.cart) {
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:cart:change", {
                bubbles: true,
              })
            );
          }

          // Check for Crash Product
          checkCartForCrashProduct(data);
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          // If there's an error, submit the form normally
          form.submit();
        });
    });
  });

  //Function Check For Crash Product
  function checkCartForCrashProduct(data){
    // Map helmet product types to insurance variant IDs
    const insuranceMap = {
      "hedonist_crash_replacement": 56507125399933,        // Hedonist Crash Insurance variantId
      "epicurist_crash_replacement": 56507139522941,      // Epicurist Crash Insurance variantId
      "heroine_claasic_crash_replacement": 56507146600829, // Heroine Classic Crash Insurance variantId
      "heroine_racer_crash_replacement": 56507132576125   // Heroine Racer Crash Insurance variantId
    };
    // Normalize product_type from added product
    const productType = (data.product_type || "").toLowerCase();
    // Check if product type matches any insuranceMap key
    // if (insuranceMap[productType]) {
    //   const insuranceVariantId = insuranceMap[productType];
    //   fetch("/cart.js")
    //     .then(res => res.json())
    //     .then(cart => {
    //       const exists = cart.items.some(item => item.id == insuranceVariantId);
    //       if (!exists) {
    //         addCrashProductToCart(insuranceVariantId, productVID);
    //       }
    //     })
    //     .catch(err => console.error("Error checking cart for insurance:", err));
    //   return; // If matched by product type, no need to check tags
    // }

    // First fetch product details using its handle or ID
    fetch(`/products/${data.handle}.js`)  // OR another way if handle is not present
      .then(res => res.json())
      .then(product => {
        const tags = (product.tags || []).map(tag => tag.toLowerCase());
        for (let tag in insuranceMap) {
          if (tags.includes(tag)) {
            const insuranceVariantId = insuranceMap[tag];

            // Check if insurance already exists in cart
            fetch("/cart.js")
              .then(res => res.json())
              .then(cart => {
                const exists = cart.items.some(item => item.id == insuranceVariantId);
                if (!exists) {
                  addCrashProductToCart(insuranceVariantId);
                }
              })
              .catch(err => console.error("Error checking cart for insurance:", err));

            break; // Stop checking after first match
          }
        }
      })
      .catch(err => console.error("Error fetching product details:", err));
  }

const submitButton = form.querySelector('button[type="submit"]');

let isAdding = false;

form.addEventListener('submit', function (event) {
  event.preventDefault();
  
  if (isAdding) return; // Prevent duplicate submissions
  isAdding = true;
  
  const formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    updateSubtotalPrice();
    updateCartDrawer();
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  })
  .finally(() => {
    isAdding = false; // Reset flag after completion
  });
});

form.addEventListener('submit', function (event) {
  event.preventDefault();
  event.stopImmediatePropagation(); // Stop other listeners
  
  // Your add to cart logic here
  fetch('/cart/add.js', {
    method: 'POST',
    body: new FormData(form),
  })
  .then(response => response.json())
  .then(data => {
    updateSubtotalPrice();
    updateCartDrawer();
  });
}, { capture: true }); // Use capture phase to run first


  // Reusable function to add a product by variant ID
  function addCrashProductToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        quantity: 1,
        id: variantId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // Fire theme event
        
        document.dispatchEvent(new CustomEvent("theme:cart:init", { bubbles: true }));

        // 🔑 Optional: force open cart drawer if closed
        const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(
            new CustomEvent("theme:drawer:open", {
              bubbles: true,
              detail: { cart: data, customParam: "crashProductAdded" }
            })
          );
        }
      })
      .catch((err) => console.error("Error adding insurance:", err));
  }

  // Function to show the upsell popup
  function showUpsellPopup() {
    // Check if the popup section exists
    const popupElement = document.getElementById("helmet-upsell-popup");

    if (popupElement) {
      console.log("Found existing popup element, showing it");
      popupElement.style.display = "flex";

      // Initialize popup functionality
      initializePopup(popupElement);
    } else {
      console.error(
        "Popup element not found. Make sure the section is properly added to your theme."
      );
    }
  }

  // Function to initialize popup functionality
  function initializePopup(popupElement) {
    // Continue to checkout button
    const continueButton = popupElement.querySelector(".continue-checkout");
    if (continueButton) {
      continueButton.addEventListener("click", function () {
        window.location.href = "/checkout";
      });
    }

    // Dismiss button
    const dismissButton = popupElement.querySelector(".dismiss-upsell");
    if (dismissButton) {
      dismissButton.addEventListener("click", function () {
        popupElement.style.display = "none";
      });
    }

    // Initialize each product in the popup
    const productContainers = popupElement.querySelectorAll(".upsell-product");
    productContainers.forEach((container) => {
      initializeProductContainer(container);
    });
  }

  // Function to initialize a single product container
  function initializeProductContainer(container) {
    // Get the Add to Cart button
    const addButton = container.querySelector(".add-to-cart-upsell");
    if (!addButton) return;

    // Add click event to the Add to Cart button
    addButton.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      if (variantId) {
        addUpsellToCart(variantId, this);
      }
    });

    // Initialize color swatches
    initializeColorSwatches(container);

    // Initialize image slider
    initializeImageSlider(container);

    // Select the first color swatch by default
    const firstSwatch = container.querySelector(".color-swatch");
    if (firstSwatch) {
      firstSwatch.classList.add("selected");
    }
  }

  // Function to initialize color swatches
  function initializeColorSwatches(container) {
    const colorSwatches = container.querySelectorAll(".color-swatch");

    colorSwatches.forEach((swatch, index) => {
      swatch.addEventListener("click", function () {
        // Update selected state
        container.querySelectorAll(".color-swatch").forEach((s) => {
          s.classList.remove("selected");
        });
        this.classList.add("selected");

        // Show the corresponding image slide
        showSlide(container, index);
      });
    });
  }

  // Function to initialize image slider
  function initializeImageSlider(container) {
    const dots = container.querySelectorAll(".dot");

    // Add click events to dots
    dots.forEach((dot, index) => {
      dot.addEventListener("click", function () {
        showSlide(container, index);

        // Update the selected color swatch
        updateSelectedColorSwatch(container, index);
      });
    });

    // Add navigation arrows
    addNavigationArrows(container);

    // Add touch support for mobile
    addTouchSupport(container);
  }

  // Function to add navigation arrows
  function addNavigationArrows(container) {
    const slides = container.querySelectorAll(".product-image-slide");
    const imageContainer = container.querySelector(".product-image-container");

    if (imageContainer && slides.length > 1) {
      const prevArrow = document.createElement("div");
      prevArrow.className = "slider-arrow prev";
      prevArrow.innerHTML = "&#10094;";

      const nextArrow = document.createElement("div");
      nextArrow.className = "slider-arrow next";
      nextArrow.innerHTML = "&#10095;";

      imageContainer.appendChild(prevArrow);
      imageContainer.appendChild(nextArrow);

      // Add click events to arrows
      prevArrow.addEventListener("click", function () {
        navigateSlider(container, "prev");
      });

      nextArrow.addEventListener("click", function () {
        navigateSlider(container, "next");
      });
    }
  }

  // Function to update the selected color swatch based on the image
  function updateSelectedColorSwatch(container, imageIndex) {
    const colorSwatches = container.querySelectorAll(".upsell-popup .color-swatch");

    // If we have the same number of swatches as images, select the corresponding swatch
    if (colorSwatches.length > imageIndex) {
      colorSwatches.forEach((swatch) => {
        swatch.classList.remove("selected");
      });

      colorSwatches[imageIndex].classList.add("selected");
    }
  }

  // Function to show a specific slide
  function showSlide(container, index) {
    const slides = container.querySelectorAll(".product-image-slide");
    const dots = container.querySelectorAll(".dot");

    // Hide all slides
    slides.forEach((slide) => {
      slide.classList.remove("active");
    });

    // Remove active class from all dots
    dots.forEach((dot) => {
      dot.classList.remove("active");
    });

    // Show the selected slide
    if (slides[index]) {
      slides[index].classList.add("active");
    }

    // Highlight the selected dot
    if (dots[index]) {
      dots[index].classList.add("active");
    }
  }

  // Function to navigate slider (prev/next)
  function navigateSlider(container, direction) {
    const slides = container.querySelectorAll(".product-image-slide");
    const activeSlide = container.querySelector(".product-image-slide.active");

    if (!activeSlide || slides.length <= 1) return;

    let currentIndex = Array.from(slides).indexOf(activeSlide);
    let newIndex;

    if (direction === "prev") {
      newIndex = (currentIndex - 1 + slides.length) % slides.length;
    } else {
      newIndex = (currentIndex + 1) % slides.length;
    }

    showSlide(container, newIndex);
    updateSelectedColorSwatch(container, newIndex);
  }

  // Function to add touch swipe support
  function addTouchSupport(container) {
    const imageContainer = container.querySelector(".product-image-container");
    if (!imageContainer) return;

    let touchStartX = 0;
    let touchEndX = 0;

    imageContainer.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    imageContainer.addEventListener(
      "touchend",
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      },
      { passive: true }
    );

    function handleSwipe() {
      const threshold = 50; // Minimum distance required for swipe

      if (touchEndX < touchStartX - threshold) {
        // Swipe left (next)
        navigateSlider(container, "next");
      } else if (touchEndX > touchStartX + threshold) {
        // Swipe right (prev)
        navigateSlider(container, "prev");
      }
    }
  }

  // Function to add an upsell product to cart
  function addUpsellToCart(variantId, button) {
    // Show loading state
    const originalText = button.textContent;
    button.textContent = "ADDING...";
    button.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Upsell product added to cart:", data);

        // Update cart count/drawer if needed
        if (window.theme && window.theme.cart) {
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:cart:change", {
              bubbles: true,
            })
          );
        }

        // Show success state
        button.textContent = "ADDED!";

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding upsell product to cart:", error);

        // Show error state
        button.textContent = "ERROR";

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
  }

  // Initialize the popup if it's already in the DOM
  const existingPopup = document.getElementById("helmet-upsell-popup");
  if (existingPopup) {
    initializePopup(existingPopup);
  }
});
